import { useContext } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import DelsystemRouter from '../DelsystemRouter/DelsystemRouter';
import RutinRouter from '../RutinRouter/RutinRouter';
import {
  rutinRouteName,
  styrvardeRouteName,
  debugRouteName,
  loginRouteName,
} from '../router';
import DelsystemLista, {
  IDelsystem,
} from '../../Delsystem/_Common/Const/Delsystem';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import { getURLPart } from '../Utils/authorizationUtils';
import { isUnderTest } from '../../../Utils/isDevelopment';
import ParserDemo from '../..//Dev/ParserDemo/ParserDemo';
import IconDemo from '../../Dev/IconDemo/IconDemo';
import { EDGraphiQL } from '../..//Dev/GraphiQL/GraphiQL';
import { GraphExamples } from '../../Dev/GraphExamples/GraphExamples';
import LoggerDemo from '../../Dev/LoggerDemo/LoggerDemo';
import isDevelopment from '../../../Utils/isDevelopment';
import ErrorBoundary from '../../../Components/ErrorBoundary/ErrorBoundary';
import { useActiveDatabaseName } from '../../../Hooks/useActiveDatabaseName';
import {
  ActiveDatabaseContext,
  IActiveDatabaseContext,
} from '../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import Login from '../../Login/Login';
import LoginPage from '../../Login/Components/LoginPage/LoginPage';
import { StartPanel } from '../../StartPanel/StartPanel';
import ProcessesPage from '../../Processes/ProcessesPage';
import { DebugRutinViewRoute } from '../../Dev/DebugRutin/DebugRutin';

const DeniedAccessDelsystem = (props: { delsystem: IDelsystem }) => {
  return (
    <EDTypography>{`Du har ej tillgång till delsystemet ${props.delsystem.benamning}`}</EDTypography>
  );
};

const delsystemPartInUrl = 2;

const ErrorComponent = (props: {
  activeDatabaseContext: IActiveDatabaseContext;
}) => {
  const location = useLocation();
  const triedDelsystem = getURLPart(delsystemPartInUrl, location.pathname);

  const delsystem: IDelsystem | undefined = DelsystemLista.filter(
    ds => ds.path === triedDelsystem
  )[0];

  if (props.activeDatabaseContext?.activeDatabaseInfoLoading) {
    return null;
  } else if (delsystem != null) {
    return <DeniedAccessDelsystem delsystem={delsystem} />;
  } else {
    return <Navigate to="/" replace />;
  }
};

const DBRouter = () => {
  const databaseName = useActiveDatabaseName();
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const availableDelsystem = activeDatabaseContext.availableDelsystem ?? [];
  return (
    <>
      <Login />
      <Routes>
        <Route index element={<StartPanel />} />
        {availableDelsystem.map(delsystem => (
          <Route
            key={delsystem.code}
            path={`${delsystem.path}/*`}
            element={
              <DelsystemRouter dbName={databaseName} delsystem={delsystem} />
            }
          />
        ))}
        <Route
          key={rutinRouteName}
          path={`${rutinRouteName}/:rutinURL`}
          element={<RutinRouter />}
        >
          <Route index element={null} />
          <Route path="*" element={null} />
        </Route>
        <Route
          key={loginRouteName}
          path={loginRouteName}
          element={<LoginPage />}
        />
        <Route
          key={styrvardeRouteName}
          path={`${styrvardeRouteName}/:rutinURL`}
          element={<RutinRouter styrvarden />}
        >
          <Route index element={null} />
          <Route path="*" element={null} />
        </Route>
        {isUnderTest() && (
          <>
            <Route
              key={`${debugRouteName}-redirect`}
              path={debugRouteName}
              element={
                <Navigate to={`LRLeverantor/standard/rtnLeverantorer`} />
              }
            />
            <Route
              key={debugRouteName}
              path={`${debugRouteName}/:collectionName/:detaljVy/:rutinKod`}
              element={<DebugRutinViewRoute />}
            >
              <Route index element={null} />
              <Route path="*" element={null} />
            </Route>
          </>
        )}
        {window.env.showDemoComponents && (
          <Route path="processes" element={<ProcessesPage />} />
        )}
        {isDevelopment && (
          <Route path="chartexample" element={<GraphExamples />} />
        )}
        {isDevelopment && <Route path="graphiql" element={<EDGraphiQL />} />}
        {isDevelopment && <Route path="parserDemo" element={<ParserDemo />} />}
        {isDevelopment && <Route path="iconDemo" element={<IconDemo />} />}
        {isDevelopment && <Route path="loggerDemo" element={<LoggerDemo />} />}
        <Route
          path="*"
          element={
            <ErrorComponent activeDatabaseContext={activeDatabaseContext} />
          }
        />
      </Routes>
    </>
  );
};

const EnhancedDBRouter = () => {
  return (
    <ErrorBoundary name="DBRouter">
      <DBRouter />
    </ErrorBoundary>
  );
};

export default EnhancedDBRouter;
